
import TemperatureConverterUtil from '@/util/TemperatureConverterUtil'
import { toNumber } from 'lodash'

/**
 * Shared component with utilities to make working with temperatures in
 * components easier. Expects to be mixed in with components that expose
 * customerContext (achieved through the CurrentUserMixin)
 */
var TemperatureMixin = {
  methods: {
    /**
     * Return a temperature that is in the appropriate scale (based on customer
     * context) and level of precision
     *
     * @param Float temperature numeric value of temperature
     * @param String from optional indicator of the scale of the temperature
     * accepts 'c' (default) or 'f'
     * @param String to optional indicator of the scale to which the value
     * should be converted accepts 'c' or 'f'. Defaults to the current customer
     * setting
     * @param Boolean strictConversion By default when the temperature provided
     * is null or undefined this function will return the equivalent of 0c. When
     * this is set to true the return value will be undefined if the provided
     * temperature is not a number
     *
     * @return Float
     */
    temperatureToCustomerScale (temperature, from = 'c', to = this.customerContext.tempFormat(), strictConversion = false) {
      if (strictConversion && typeof temperature !== 'number') {
        return undefined
      }
      try {
        return toNumber(TemperatureConverterUtil.to(temperature, from, to).toFixed(1))
      } catch (error) {
        return toNumber(temperature)
      }
    },
    formatTemperature: TemperatureConverterUtil.formatTemperature
  },
  filters: {
    temperatureToScale: function (value, from, to) {
      return TemperatureConverterUtil.to(value, from, to).toFixed(1)
    }
  }
}

export default TemperatureMixin
